import React, { RefObject } from "react";
import { Box, Flex, Image, Table, Thead, Tbody, Tr, Th, Td, Text } from "@chakra-ui/react";
import { DateTime } from "luxon";
import { ProductionOrderViewModel } from "../../../models/Production";

interface Props {
  printRef: RefObject<any>;
  orders: ProductionOrderViewModel[];
}

const ProductionPrint: React.FC<Props> = ({ printRef, orders }) => {
  return (
    <Box ref={printRef} p="24px" bg="white">
      <Flex align="center" gap="16px" mb="24px">
        <Image src="/grupoCvfLogo.png" alt="CVF" h="48px" />
        <Text fontSize="20px" fontWeight="700">
          Backorder — {DateTime.now().toFormat("dd/LL/yyyy")}
        </Text>
      </Flex>
      <Table size="sm">
        <Thead>
          <Tr>
            <Th>Nº Processo</Th>
            <Th>Abertura</Th>
            <Th>Início produção</Th>
            <Th>Nº Containers</Th>
            <Th>Origem</Th>
            <Th>Marca</Th>
            <Th>Fábrica</Th>
            <Th>Categoria</Th>
            <Th>Prontidão estimada</Th>
            <Th>Status</Th>
          </Tr>
        </Thead>
        <Tbody>
          {orders.map((o) => (
            <Tr key={o.id}>
              <Td>{o.processCvfRef ?? "—"}</Td>
              <Td>{o.processOpeningDate ? DateTime.fromISO(o.processOpeningDate).toFormat("dd/LL/yyyy") : ""}</Td>
              <Td>{o.productionStartDate ? DateTime.fromISO(o.productionStartDate).toFormat("dd/LL/yyyy") : ""}</Td>
              <Td>{o.containerQuantity}</Td>
              <Td>{o.origin}</Td>
              <Td>{o.brand}</Td>
              <Td>{o.factory}</Td>
              <Td>{o.category}</Td>
              <Td>
                {(o.expectedReadinessDate ?? o.estimatedReadinessDate)
                  ? DateTime.fromISO((o.expectedReadinessDate ?? o.estimatedReadinessDate)!).toFormat("dd/LL/yyyy")
                  : ""}
              </Td>
              <Td>{o.status}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default ProductionPrint;
